import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { availableQuantityZodSchema } from "@@/shared/units-and-quantities/quantity";
import { unitZodSchema } from "@@/shared/units-and-quantities/unit";
import type { Except } from "type-fest";
import { z } from "zod";
import { resourceIdFactory, resourceIdZodSchema } from "./resource-id";
import { resourceShortNameZodString } from "./resource.short-name";

/**
 * Local to session and product (not shared)
 */

const resourceLocalZodSchema = z.object({
    _id: resourceIdZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("RESOURCE_LOCAL"),
    meta: metaContentZodSchema,
    quantity: availableQuantityZodSchema,
    unit: unitZodSchema,
    /**
     * Optional short name, e.g. B12
     * if not set a short name will be generated based on
     * the title when needed. Max 5 chars.
     */
    shortName: resourceShortNameZodString.optional(),
});
type ResourceLocal = z.infer<typeof resourceLocalZodSchema>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isResourceLocal = (item: any): item is ResourceLocal => {
    return item._type === "RESOURCE_LOCAL";
};

type FactoryParams = Except<ResourceLocal, "_createdAt" | "_id" | "_type">;
const resourceLocalFactory = (params: FactoryParams): ResourceLocal => {
    return {
        _id: resourceIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "RESOURCE_LOCAL",
        ...params,
    };
};

export { isResourceLocal, resourceLocalFactory, resourceLocalZodSchema };
export type { ResourceLocal };
